export default __webpack_public_path__ + "static/media/mint_title.2d3d88a7.png";